module.exports = __webpack_public_path__ + "img/apple_wallet.7d8456b5.png";